import "./navbar/btns-group.scss";
import { currentDomain } from "../../utils/general-config";
import { DomainEnum } from "../../services/enum/environment-enum";
import SSHeader from "./ss";
import LSHeader from "./ls";
import PSHeader from "./ps";
import RBHeader from "./rb";
import WSHeader from "./ws";
const Header = () => {
  return (
    <>
      {(() => {
        const domain = currentDomain().toLowerCase();
        switch (domain) {
          case DomainEnum.RESUMEBUILD:
            return <RBHeader />;
          case DomainEnum.WORKSIMPLI:
            return <WSHeader />;
          case DomainEnum.PDFSIMPLI:
            return <PSHeader />;
          case DomainEnum.LEGALSIMPLI:
            return <LSHeader />;
          case DomainEnum.SIGNSIMPLI:
            return <SSHeader />;
          default:
            return null;
        }
      })()}
    </>
  );
};
export default Header;
